// extracted by mini-css-extract-plugin
export default {"Loading":"CourseTopicSkeleton_Loading__eDi+L","load":"CourseTopicSkeleton_load__FMFhV"};